export const BOT_TEXT_DELAY = 500
export const BOT_REPLY_DELAY = 1000

export const contentListItemKey = Symbol('contentListItem')
export const contentMessageAttachmentKey = Symbol('contentMessageAttachment')

export const REPLIES_ID_SUFFIX = '-replies'

export const MESSAGE_SOUND_VOLUME = 0.35
export const MESSAGE_SOUND_THROTTLING = 5000

export const MAX_IMAGE_HEIGHT = 240
